(function () {
  'use strict';
  if (window.__owCbV1) return;
  window.__owCbV1 = true;
  var W = window, D = document, HTML = D.documentElement;
  var OW_CUR = {"USD":["$",2,"US dollar"],"EUR":["\u20ac",2,"Euro"],"GBP":["\u00a3",2,"British pound"],"CAD":["CA$",2,"Canadian dollar"],"AUD":["A$",2,"Australian dollar"],"NZD":["NZ$",2,"New Zealand dollar"],"JPY":["\u00a5",0,"Japanese yen"],"CHF":["CHF ",2,"Swiss franc"],"SEK":["SEK ",2,"Swedish krona"],"NOK":["NOK ",2,"Norwegian krone"],"DKK":["DKK ",2,"Danish krone"],"PLN":["PLN ",2,"Polish z\u0142oty"],"CZK":["CZK ",2,"Czech koruna"],"HUF":["HUF ",2,"Hungarian forint"],"RON":["RON ",2,"Romanian leu"],"ISK":["ISK ",0,"Icelandic kr\u00f3na"],"TRY":["\u20ba",2,"Turkish lira"],"ILS":["\u20aa",2,"Israeli shekel"],"INR":["\u20b9",2,"Indian rupee"],"SGD":["S$",2,"Singapore dollar"],"HKD":["HK$",2,"Hong Kong dollar"],"MXN":["MX$",2,"Mexican peso"],"BRL":["R$",2,"Brazilian real"],"ZAR":["ZAR ",2,"South African rand"],"KRW":["\u20a9",0,"South Korean won"],"CNY":["CN\u00a5",2,"Chinese yuan"],"PHP":["\u20b1",2,"Philippine peso"],"THB":["\u0e3f",2,"Thai baht"],"MYR":["RM ",2,"Malaysian ringgit"],"IDR":["IDR ",2,"Indonesian rupiah"]};
/* code given and without decimals (JPY / KRW / ISK): rounded ONCE to the whole unit (x 100), like fx.ts convertCents. */
function owConv(c, rate, code) {
  if (!isFinite(c) || !isFinite(rate) || !(rate > 0)) return NaN;
  var raw = Math.round(c * rate * 1e6) / 1e6;
  var info = code ? OW_CUR[code] : null;
  if (info && info[1] === 0) { var u = raw / 100; return (u >= 0 ? Math.floor(u + 0.5) : -Math.floor(-u + 0.5)) * 100; }
  return raw >= 0 ? Math.floor(raw + 0.5) : -Math.floor(-raw + 0.5);
}
function owFormatOk(f) {
  if (f == null || f === '') return true;
  f = String(f).replace(/&#0*36;|&#x0*24;|&dollar;/gi, '$').replace(/<[^>]*>/g, '|');
  return /(^|[^A-Za-z0-9$])\$\s?\{\{\s*amount\s*\}\}/.test(f);
}
function owGroup(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
function owFmt(cents, code) {
  if (!isFinite(cents)) return '';
  var info = OW_CUR[code], sym = info ? info[0] : code + ' ', dec = info ? info[1] : 2;
  var neg = cents < 0, abs = Math.abs(cents), body;
  if (dec === 0) body = owGroup(String(Math.floor(abs / 100 + 0.5)));
  else {
    var whole = Math.floor(abs / 100), frac = String(abs - whole * 100);
    if (frac.length < 2) frac = '0' + frac;
    body = owGroup(String(whole)) + '.' + frac;
  }
  return (neg ? '-' : '') + sym + body;
}
/* "$8.99", "$8.99 USD", "$1,234.5" inside any text; never "CA$" / "A$" / "US$" (a letter before the $). */
var OW_MONEY_RE = /(^|[^A-Za-z0-9$])\$[ \u00a0]?((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?)(?:[ \u00a0]?USD\b)?/g;
function owConvertText(t, rate, code) {
  if (!t || t.indexOf('$') === -1 || !(rate > 0)) return null;
  var hit = false;
  var out = t.replace(OW_MONEY_RE, function (m, pre, num) {
    var c = Math.round(parseFloat(num.replace(/,/g, '')) * 100);
    if (!isFinite(c)) return m;
    hit = true;
    return pre + owFmt(owConv(c, rate, code), code);
  });
  return hit ? out : null;
}

  var FLAG_SVG = {"USD":"<svg viewBox=\"0 0 20 14\" preserveAspectRatio=\"none\" aria-hidden=\"true\"><rect width=\"20\" height=\"14\" fill=\"#fff\"/><path d=\"M0 0h20v1.08H0zM0 2.15h20v1.08H0zM0 4.31h20v1.08H0zM0 6.46h20v1.08H0zM0 8.62h20v1.08H0zM0 10.77h20v1.08H0zM0 12.92h20V14H0z\" fill=\"#b22234\"/><rect width=\"8\" height=\"7.54\" fill=\"#3c3b6e\"/></svg>","GBP":"<svg viewBox=\"0 0 60 30\" preserveAspectRatio=\"none\" aria-hidden=\"true\"><rect width=\"60\" height=\"30\" fill=\"#012169\"/><path d=\"M0,0 60,30M60,0 0,30\" stroke=\"#fff\" stroke-width=\"6\"/><path d=\"M0,0 60,30M60,0 0,30\" stroke=\"#c8102e\" stroke-width=\"2\"/><path d=\"M30,0v30M0,15h60\" stroke=\"#fff\" stroke-width=\"10\"/><path d=\"M30,0v30M0,15h60\" stroke=\"#c8102e\" stroke-width=\"6\"/></svg>","CAD":"<svg viewBox=\"0 0 40 20\" preserveAspectRatio=\"none\" aria-hidden=\"true\"><rect width=\"40\" height=\"20\" fill=\"#fff\"/><rect width=\"10\" height=\"20\" fill=\"#d52b1e\"/><rect x=\"30\" width=\"10\" height=\"20\" fill=\"#d52b1e\"/><path d=\"M20 4l1.2 2.4 1.6-.6-.6 3.4 2-1.6.4 1.2 2-.4-.8 2 .8.4-3.4 2.6.4 1.2-3.4-.4V17h-.6v-2.8l-3.4.4.4-1.2-3.4-2.6.8-.4-.8-2 2 .4.4-1.2 2 1.6-.6-3.4 1.6.6z\" fill=\"#d52b1e\"/></svg>","AUD":"<svg viewBox=\"0 0 40 20\" preserveAspectRatio=\"none\" aria-hidden=\"true\"><rect width=\"40\" height=\"20\" fill=\"#012169\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#fff\" stroke-width=\"2\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#c8102e\" stroke-width=\".8\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#fff\" stroke-width=\"3\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#c8102e\" stroke-width=\"1.8\"/><g fill=\"#fff\"><circle cx=\"10\" cy=\"15\" r=\"1.8\"/><circle cx=\"30\" cy=\"4\" r=\".9\"/><circle cx=\"26\" cy=\"9\" r=\".9\"/><circle cx=\"33\" cy=\"8\" r=\".9\"/><circle cx=\"30\" cy=\"16\" r=\".9\"/><circle cx=\"31.5\" cy=\"11\" r=\".5\"/></g></svg>","EUR":"<svg viewBox=\"0 0 30 20\" preserveAspectRatio=\"none\" aria-hidden=\"true\"><rect width=\"30\" height=\"20\" fill=\"#039\"/><g fill=\"#fc0\"><circle cx=\"15\" cy=\"4\" r=\".9\"/><circle cx=\"18\" cy=\"4.8\" r=\".9\"/><circle cx=\"20.2\" cy=\"7\" r=\".9\"/><circle cx=\"21\" cy=\"10\" r=\".9\"/><circle cx=\"20.2\" cy=\"13\" r=\".9\"/><circle cx=\"18\" cy=\"15.2\" r=\".9\"/><circle cx=\"15\" cy=\"16\" r=\".9\"/><circle cx=\"12\" cy=\"15.2\" r=\".9\"/><circle cx=\"9.8\" cy=\"13\" r=\".9\"/><circle cx=\"9\" cy=\"10\" r=\".9\"/><circle cx=\"9.8\" cy=\"7\" r=\".9\"/><circle cx=\"12\" cy=\"4.8\" r=\".9\"/></g></svg>"};
  var FLAG_EMOJI = {"USD":"\ud83c\uddfa\ud83c\uddf8","EUR":"\ud83c\uddea\ud83c\uddfa","GBP":"\ud83c\uddec\ud83c\udde7","CAD":"\ud83c\udde8\ud83c\udde6","AUD":"\ud83c\udde6\ud83c\uddfa","NZD":"\ud83c\uddf3\ud83c\uddff","JPY":"\ud83c\uddef\ud83c\uddf5","CHF":"\ud83c\udde8\ud83c\udded","SEK":"\ud83c\uddf8\ud83c\uddea","NOK":"\ud83c\uddf3\ud83c\uddf4","DKK":"\ud83c\udde9\ud83c\uddf0","PLN":"\ud83c\uddf5\ud83c\uddf1","CZK":"\ud83c\udde8\ud83c\uddff","HUF":"\ud83c\udded\ud83c\uddfa","RON":"\ud83c\uddf7\ud83c\uddf4","ISK":"\ud83c\uddee\ud83c\uddf8","TRY":"\ud83c\uddf9\ud83c\uddf7","ILS":"\ud83c\uddee\ud83c\uddf1","INR":"\ud83c\uddee\ud83c\uddf3","SGD":"\ud83c\uddf8\ud83c\uddec","HKD":"\ud83c\udded\ud83c\uddf0","MXN":"\ud83c\uddf2\ud83c\uddfd","BRL":"\ud83c\udde7\ud83c\uddf7","ZAR":"\ud83c\uddff\ud83c\udde6","KRW":"\ud83c\uddf0\ud83c\uddf7","CNY":"\ud83c\udde8\ud83c\uddf3","PHP":"\ud83c\uddf5\ud83c\udded","THB":"\ud83c\uddf9\ud83c\udded","MYR":"\ud83c\uddf2\ud83c\uddfe","IDR":"\ud83c\uddee\ud83c\udde9"};

  function noop() {}
  function warn(name, e) { try { console.warn('[OpenWeav Booster] ' + name + ' stopped:', e && e.message ? e.message : e); } catch (x) {} }
  function safe(name, fn) { try { fn(); } catch (e) { warn(name, e); } }
  function unhold() {
    try { HTML.className = HTML.className.replace(/(^|\s)ow-cb-hold(?=\s|$)/g, ''); } catch (e) {}
  }
  function lsGet(k) { try { return W.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { W.localStorage.setItem(k, v); } catch (e) {} }
  function raf(fn) { (W.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(fn); }
  function addClass(el, c) { if ((' ' + el.className + ' ').indexOf(' ' + c + ' ') === -1) el.className = (el.className ? el.className + ' ' : '') + c; }
  function removeClass(el, c) { el.className = (' ' + el.className + ' ').replace(' ' + c + ' ', ' ').replace(/^\s+|\s+$/g, ''); }
  function textNode(el, value) {
    /* One text node per element we own: later updates change nodeValue only (no removed nodes). */
    var t = D.createTextNode(value == null ? '' : String(value));
    el.appendChild(t);
    return t;
  }
  function setText(t, value) { value = value == null ? '' : String(value); if (t.nodeValue !== value) t.nodeValue = value; }
  function cleanText(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, ''); }

  var cfg = null;
  try {
    var cfgEl = D.getElementById('ow-booster-config');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent || 'null') : null;
  } catch (e) { cfg = null; }
  if (!cfg || !cfg.c || cfg.c.v !== 1) { unhold(); return; }
  var C = cfg.c, FX = cfg.fx || null, SHOP = cfg.shop || {}, PAGE = cfg.page || {};
  var BASE = String(SHOP.currency || 'USD').toUpperCase();
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || SHOP.root || '/';
  var PRODUCT = PAGE.t === 'product' && PAGE.p ? PAGE.p : null;

  /* ?ow_preview=1 \u2014 run every feature even while Vitals is still installed (for the store owner's check). */
  var PREVIEW = false;
  try {
    var pm = /[?&]ow_preview=([01])(?:&|$)/.exec(W.location.search || '');
    if (pm) W.sessionStorage.setItem('ow_cb_preview', pm[1]);
    PREVIEW = W.sessionStorage.getItem('ow_cb_preview') === '1';
  } catch (e) {}
  function vitalsHas(n) {
    if (PREVIEW) return false;
    try { var m = W.vtlsLiquidData && W.vtlsLiquidData.moduleSettings; return !!(m && m[String(n)]); } catch (e) { return false; }
  }

  /* \u2500\u2500 One body observer shared by every feature \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var subs = [], obs = null;
  function dispatch(recs) {
    for (var i = 0; i < subs.length; i++) { try { subs[i](recs); } catch (e) { warn('observer', e); } }
    /* Our own writes made during this callback are not news for us. */
    if (obs) { try { obs.takeRecords(); } catch (e) {} }
  }
  function onDom(fn) {
    subs.push(fn);
    if (obs || !W.MutationObserver || !D.body) return;
    obs = new MutationObserver(dispatch);
    obs.observe(D.body, { childList: true, subtree: true, characterData: true });
  }
  /* Once per frame, whatever changed (sticky mirror, labels, cart note). */
  function onDomFrame(fn) {
    var queued = false;
    onDom(function () {
      if (queued) return;
      queued = true;
      raf(function () { queued = false; try { fn(); } catch (e) { warn('frame', e); } });
    });
  }

  /* Bottom offset for the fixed buttons while the sticky bar shows. */
  function setLift(px) { try { HTML.style.setProperty('--ow-cb-lift', (px > 0 ? px : 0) + 'px'); } catch (e) {} }

  /* \u2500\u2500 1. Currency converter \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var OWB = { version: 1, base: BASE, currency: function () { return BASE; }, rate: function () { return 1; },
    format: function (cents, code) { return owFmt(Number(cents), code || BASE); }, convert: function (cents) { return Number(cents); },
    setCurrency: noop, onChange: noop };
  W.OWBooster = OWB;

  safe('currency', function () {
    var cur = C.currency;
    if (!cur || vitalsHas(30)) { unhold(); return; }
    var active = W.Shopify && W.Shopify.currency && W.Shopify.currency.active;
    var usable = !!FX && !!FX.rates && String(FX.base).toUpperCase() === BASE && BASE === 'USD' && typeof WeakMap === 'function' && !!D.createTreeWalker
      && (!active || String(active).toUpperCase() === BASE)
      /* Only a format whose prices the reader can find ("$8.99"): on "US$8.99" / "8.99 USD" the selector
         and the cart notice would show while nothing converts (fix 2026-10-07). */
      && owFormatOk(SHOP.moneyFormat);
    if (usable) {
      var age = Date.now() - Number(FX.ts);
      usable = age >= -129600000 && age <= 604800000;
    }
    if (!usable) { unhold(); return; }
    var LIST = [BASE];
    for (var li = 0; li < (cur.list || []).length; li++) {
      var lc = String(cur.list[li]).toUpperCase();
      if (lc !== BASE && OW_CUR[lc] && FX.rates[lc] > 0 && LIST.indexOf(lc) === -1) LIST.push(lc);
    }
    if (LIST.length < 2) { unhold(); return; }
    var COUNTRIES = cur.countries || {};
    var CHOSEN = 'ow_cb_cur', GEO = 'ow_cb_geo';
    function valid(code) { return !!code && LIST.indexOf(code) !== -1; }
    function geoCached() {
      try { var g = JSON.parse(lsGet(GEO) || 'null'); if (g && g.c && Date.now() - g.t < 86400000) return g; } catch (e) {}
      return null;
    }
    function fromCountry(c) { var code = COUNTRIES[String(c || '').toUpperCase()]; return valid(code) ? code : BASE; }

    var current = BASE;
    var manual = lsGet(CHOSEN);
    if (valid(manual)) current = manual;
    else if (cur.auto) { var gc = geoCached(); if (gc) current = fromCountry(gc.c); }

    var rec = new WeakMap(); /* text node \u2192 { o: original store-currency text, w: what we wrote, n: writes, t: first write ms } */
    var listeners = [];
    function skipped(el) {
      for (var e = el, d = 0; e && e !== D.body && d < 60; e = e.parentNode, d++) {
        if (e.nodeType !== 1) continue;
        var tn = e.nodeName;
        if (tn === 'SCRIPT' || tn === 'STYLE' || tn === 'NOSCRIPT' || tn === 'TEXTAREA' || tn === 'TEMPLATE' || tn === 'TITLE' || tn === 'INPUT') return true;
        if (e.getAttribute && e.getAttribute('data-ow-noconv') !== null) return true;
        if (e.getAttribute && e.getAttribute('contenteditable') === 'true') return true;
        /* The review widget prints the customers' own words. (getAttribute: a form's .id can be its <input name="id">.) */
        var eid = e.getAttribute ? e.getAttribute('id') : null;
        if (eid && eid.indexOf('reviewify') === 0) return true;
      }
      return false;
    }
    var touchedButton = false;
    /* Loop guard. Another script that writes a price back to "$\u2026" each time we convert it (a
       second converter, a widget re-rendering from its own copy) would make the two observers
       call each other forever \u2014 inside one task, so the page would freeze. Every conversion
       that follows someone else's write (a new text node, or a node rewritten in place) is
       counted per parent element: more than 40 in 10 s and that element is left exactly as the
       other script writes it for the rest of the page view. Re-applying our own text (a
       currency switch) is not counted; a shopper switching packs makes 1 per switch. */
    var FIGHT_MAX = 40, FIGHT_MS = 10000;
    var fights = new WeakMap(); /* parent element \u2192 { n, t, x } */
    function gaveUp(el) { var f = el ? fights.get(el) : null; return !!(f && f.x); }
    function foreignWriteOk(el) {
      if (!el) return true;
      var now = Date.now(), f = fights.get(el);
      if (!f || now - f.t > FIGHT_MS) { f = { n: 0, t: now, x: false }; fights.set(el, f); }
      if (++f.n <= FIGHT_MAX) return true;
      f.x = true;
      warn('price', 'another script keeps rewriting a price; it is left as that script writes it');
      return false;
    }
    function apply(n) {
      var p = n.parentNode;
      if (!p) return; /* already replaced: nothing to show */
      var v = n.nodeValue, r = rec.get(n);
      var foreign = !r;
      if (r) {
        if (r.x) return;
        if (v !== r.w) { rec.delete(n); r = null; foreign = true; } /* someone else changed it: what they wrote is the new original */
      }
      var orig = r ? r.o : v;
      if (!orig || orig.indexOf('$') === -1) return;
      if (!r && skipped(p)) return;
      if (current === BASE) {
        if (r) { rec.delete(n); if (n.nodeValue !== r.o) n.nodeValue = r.o; }
        return;
      }
      if (gaveUp(p)) return;
      var out = owConvertText(orig, FX.rates[current], current);
      if (out == null) return;
      if (foreign && !foreignWriteOk(p)) return;
      var now = Date.now();
      if (r) {
        /* A node rewritten to our own text over and over (never by us) is left alone too. */
        if (now - r.t > 10000) { r.t = now; r.n = 0; }
        if (++r.n > 25) { r.x = true; return; }
      } else r = { o: orig, w: out, n: 1, t: now };
      r.o = orig; r.w = out;
      if (n.nodeValue !== out) n.nodeValue = out;
      rec.set(n, r);
      if (n.parentNode && n.parentNode.closest && n.parentNode.closest('[id^="ProductSubmitButton"]')) touchedButton = true;
    }
    function collect(root, out) {
      if (!root) return;
      if (root.nodeType === 3) { if ((root.nodeValue && root.nodeValue.indexOf('$') !== -1) || rec.has(root)) out.push(root); return; }
      if (root.nodeType !== 1 && root.nodeType !== 11) return;
      var tn = root.nodeName;
      if (tn === 'SCRIPT' || tn === 'STYLE' || tn === 'NOSCRIPT' || tn === 'TEMPLATE' || tn === 'TEXTAREA') return;
      var tw = D.createTreeWalker(root, 4, null, false), n;
      while ((n = tw.nextNode())) { if ((n.nodeValue && n.nodeValue.indexOf('$') !== -1) || rec.has(n)) out.push(n); }
    }
    /* The converted label can be wider than the store-currency one the bundle box measured:
       shorten it the same way the box does ("Add 4 patterns \u2013 \u00a3x" \u2192 "Add 4 \u2013 \u00a3x" \u2192 "Add \u2013 \u00a3x" \u2192 "\u00a3x").
       (The sticky bar is data-ow-noconv and fits its own copy of the label: see fitSticky.) */
    function refit(btnLabel) {
      if (!btnLabel || btnLabel.childNodes.length !== 1 || btnLabel.firstChild.nodeType !== 3) return;
      var n = btnLabel.firstChild, r = rec.get(n);
      if (!r || current === BASE) return;
      var fits = function () { try { return btnLabel.scrollWidth <= btnLabel.clientWidth + 1; } catch (e) { return true; } };
      if (fits()) return;
      var full = n.nodeValue, m = /^(.*?)\s+\u2013\s+(.+)$/.exec(full);
      if (!m) return;
      var cnt = /^Add (\d+)\b/.exec(m[1]);
      var options = [];
      if (cnt && m[1] !== 'Add ' + cnt[1]) options.push('Add ' + cnt[1] + ' \u2013 ' + m[2]);
      options.push('Add \u2013 ' + m[2], m[2]);
      for (var i = 0; i < options.length; i++) {
        n.nodeValue = options[i];
        r.w = options[i];
        if (fits()) return;
      }
    }
    function refitButtons() {
      if (!touchedButton) return;
      touchedButton = false;
      var labels = D.querySelectorAll('[id^="ProductSubmitButton"] > span');
      for (var i = 0; i < labels.length; i++) refit(labels[i]);
    }
    function applyAll() {
      var list = [];
      collect(D.body, list);
      for (var i = 0; i < list.length; i++) applySafe(list[i]);
      refitButtons();
    }
    /* One odd node never stops the converter. */
    function applySafe(n) { try { apply(n); } catch (e) { warn('price', e); } }
    function onMutations(recs) {
      var list = [];
      for (var i = 0; i < recs.length; i++) {
        var m = recs[i];
        if (m.type === 'characterData') { if (m.target.nodeType === 3) list.push(m.target); }
        else if (m.addedNodes) for (var j = 0; j < m.addedNodes.length; j++) collect(m.addedNodes[j], list);
      }
      if (!list.length) return;
      for (var k = 0; k < list.length; k++) {
        var n = list[k], r = rec.get(n);
        if (r && n.nodeValue === r.w) continue; /* ours */
        if (current === BASE && !r) continue;
        applySafe(n);
      }
      refitButtons();
    }

    /* Cart page: the shopper is told checkout is in the store currency. */
    var NOTE_ID = 'ow-cb-cart-note';
    function cartNote() {
      if (!cur.note || PAGE.t !== 'cart') return;
      var el = D.getElementById(NOTE_ID);
      if (current === BASE) { if (el) el.hidden = true; return; }
      var txt = 'Prices shown here are calculated in ' + current + ', but the final order will be paid in ' + BASE + '.';
      if (!el) {
        var blocks = D.querySelector('#main-cart-footer .cart__blocks') || D.querySelector('.cart__blocks');
        var totals = D.querySelector('.totals');
        if (!blocks && !totals) return;
        el = D.createElement('p');
        el.id = NOTE_ID;
        el.className = 'ow-cb-cart-note';
        el.setAttribute('data-ow-noconv', '');
        el.setAttribute('role', 'note');
        textNode(el, '');
        if (blocks) {
          var after = blocks.querySelector(':scope > .js-contents');
          if (after && after.nextSibling) blocks.insertBefore(el, after.nextSibling);
          else if (after) blocks.appendChild(el);
          else blocks.insertBefore(el, blocks.firstChild);
        } else totals.parentNode.insertBefore(el, totals.nextSibling);
      }
      setText(el.firstChild, txt);
      el.hidden = false;
    }

    /* Selector, fixed bottom-left (or right). */
    var sel = null;
    function flag(code) {
      if (FLAG_SVG[code]) return '<span class="ow-cb-flag">' + FLAG_SVG[code] + '</span>';
      return '<span class="ow-cb-flag ow-cb-flag--emoji" aria-hidden="true">' + (FLAG_EMOJI[code] || '') + '</span>';
    }
    function buildSelector() {
      var wrap = D.createElement('div');
      wrap.className = 'ow-cb-cur ow-cb-fixed ow-cb-cur--' + (cur.pos === 'bottom_right' ? 'br' : 'bl');
      wrap.setAttribute('data-ow-noconv', '');
      wrap.style.setProperty('--ow-cur-bg', cur.bg || '#ffffff');
      wrap.style.setProperty('--ow-cur-bd', cur.bd || '#f4f4f4');
      wrap.style.setProperty('--ow-cur-fg', cur.fg || '#111111');
      wrap.style.setProperty('--ow-cur-fs', (cur.fs || 14) + 'px');
      var btn = D.createElement('button');
      btn.type = 'button';
      btn.className = 'ow-cb-cur__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      var list = D.createElement('ul');
      list.className = 'ow-cb-cur__list';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Currency');
      list.hidden = true;
      for (var i = 0; i < LIST.length; i++) {
        var code = LIST[i], li = D.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('data-code', code);
        li.tabIndex = -1;
        li.className = 'ow-cb-cur__opt';
        li.innerHTML = flag(code) + '<span class="ow-cb-cur__code">' + code + '</span><span class="ow-cb-cur__name">' + (OW_CUR[code] ? OW_CUR[code][2] : '') + '</span>';
        list.appendChild(li);
      }
      wrap.appendChild(list);
      wrap.appendChild(btn);
      function paint() {
        btn.innerHTML = flag(current) + '<span class="ow-cb-cur__code">' + current + '</span><span class="ow-cb-cur__caret" aria-hidden="true"></span>';
        btn.setAttribute('aria-label', 'Currency: ' + current + '. Change currency');
        var opts = list.children;
        for (var j = 0; j < opts.length; j++) opts[j].setAttribute('aria-selected', opts[j].getAttribute('data-code') === current ? 'true' : 'false');
      }
      function open() {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var on = list.querySelector('[aria-selected="true"]') || list.firstChild;
        if (on) on.focus();
      }
      function close(focusBtn) {
        if (list.hidden) return;
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (focusBtn) btn.focus();
      }
      btn.addEventListener('click', function (e) { e.preventDefault(); if (list.hidden) open(); else close(false); });
      list.addEventListener('click', function (e) {
        var li = e.target && e.target.closest ? e.target.closest('[data-code]') : null;
        if (!li) return;
        setCurrency(li.getAttribute('data-code'), true);
        close(true);
      });
      list.addEventListener('keydown', function (e) {
        var items = list.children, at = -1;
        for (var k = 0; k < items.length; k++) if (items[k] === D.activeElement) at = k;
        if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(items.length - 1, at + 1)].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(0, at - 1)].focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (at >= 0) { setCurrency(items[at].getAttribute('data-code'), true); close(true); } }
        else if (e.key === 'Escape' || e.key === 'Tab') close(e.key === 'Escape');
      });
      D.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); }, true);
      D.body.appendChild(wrap);
      paint();
      return { paint: paint };
    }

    function setCurrency(code, byShopper) {
      code = String(code || '').toUpperCase();
      if (!valid(code)) return;
      if (byShopper) lsSet(CHOSEN, code);
      if (code === current) return;
      current = code;
      applyAll();
      if (obs) { try { obs.takeRecords(); } catch (e) {} }
      if (sel) sel.paint();
      safe('cart note', cartNote);
      for (var i = 0; i < listeners.length; i++) { try { listeners[i](current); } catch (e) {} }
      try { D.dispatchEvent(new CustomEvent('ow:currency', { detail: { currency: current, base: BASE } })); } catch (e) {}
    }

    OWB.currency = function () { return current; };
    OWB.rate = function (code) { code = code || current; return code === BASE ? 1 : (FX.rates[code] || null); };
    OWB.convert = function (cents) { return current === BASE ? Number(cents) : owConv(Number(cents), FX.rates[current], current); };
    OWB.format = function (cents, code) { code = code || current; return code === BASE ? owFmt(Number(cents), BASE) : owFmt(owConv(Number(cents), FX.rates[code], code), code); };
    OWB.setCurrency = function (code) { setCurrency(code, true); };
    OWB.onChange = function (fn) { if (typeof fn === 'function') listeners.push(fn); };
    OWB.currencies = function () { return LIST.slice(); };

    /* Back/forward cache: a restored page keeps its live state, so a currency chosen on another page
       meanwhile (Back after choosing EUR on the cart) would show the old one (fix 2026-10-07). */
    W.addEventListener('pageshow', function (e) {
      if (!e || !e.persisted) return;
      safe('currency', function () { var m = lsGet(CHOSEN); if (valid(m) && m !== current) setCurrency(m, false); });
    });

    applyAll();
    unhold();
    onDom(onMutations);
    onDomFrame(function () { if (current !== BASE && PAGE.t === 'cart' && !D.getElementById(NOTE_ID)) cartNote(); });
    safe('cart note', cartNote);
    safe('currency selector', function () { sel = buildSelector(); });

    /* The visitor's country (Shopify's own lookup, cached a day) \u2014 only until they choose themselves. */
    if (cur.auto && !valid(manual) && !geoCached() && W.fetch) {
      W.fetch(ROOT + 'browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (j) {
          var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          if (!c || !/^[A-Za-z]{2}$/.test(c)) return;
          lsSet(GEO, JSON.stringify({ c: String(c).toUpperCase(), t: Date.now() }));
          if (!valid(lsGet(CHOSEN))) setCurrency(fromCountry(c), false);
        })['catch'](noop);
    }
  });
  unhold();

  /* \u2500\u2500 2. Sticky add to cart \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('sticky', function () {
    var st = C.sticky;
    if (!st || !PRODUCT || vitalsHas(16)) return;
    function findForm() {
      var f = D.querySelector('form[data-type="add-to-cart"]');
      if (!f) { var pf = D.querySelector('product-form'); if (pf) f = pf.querySelector('form'); }
      if (!f) f = D.querySelector('form[action*="/cart/add"]');
      return f;
    }
    function findButton() {
      var f = findForm(), b = null;
      if (f) b = f.querySelector('button[type="submit"][name="add"]') || f.querySelector('button[type="submit"]') || f.querySelector('.product-form__submit');
      return b || D.querySelector('[id^="ProductSubmitButton"]');
    }
    var themeBtn = findButton();
    if (!themeBtn) return;
    function labelOf(b) {
      if (!b) return '';
      if (b.tagName === 'INPUT') return cleanText(b.value);
      var s = b.querySelector('span');
      return cleanText(s ? s.textContent : b.textContent);
    }
    function priceText() {
      var info = themeBtn.closest ? themeBtn.closest('.product__info-container, [id^="ProductInfo-"], .product') : null;
      var box = (info && info.querySelector('[id^="price-"] .price')) || D.querySelector('[id^="price-template"] .price') || null;
      if (!box) return '';
      var sale = (' ' + box.className + ' ').indexOf(' price--on-sale ') !== -1;
      var el = sale ? box.querySelector('.price__sale .price-item--sale') : box.querySelector('.price__regular .price-item--regular');
      return cleanText(el ? el.textContent : '');
    }
    var bar = D.createElement('div');
    bar.className = 'ow-cb-sticky' + (st.mobile ? '' : ' ow-cb-sticky--nomob') + (st.desktop ? '' : ' ow-cb-sticky--nodesk');
    bar.setAttribute('data-ow-noconv', '');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.setAttribute('aria-hidden', 'true');
    bar.style.setProperty('--ow-st-bg', st.bg || '#ffffff');
    bar.style.setProperty('--ow-st-fg', st.fg || '#2e2e2e');
    bar.style.setProperty('--ow-st-btn-bg', st.btnBg || '#000000');
    bar.style.setProperty('--ow-st-btn-fg', st.btnFg || '#ffffff');
    var inner = D.createElement('div'); inner.className = 'ow-cb-sticky__in'; bar.appendChild(inner);
    if (PRODUCT.img) {
      var img = D.createElement('img');
      img.className = 'ow-cb-sticky__img'; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy'; img.decoding = 'async';
      img.src = String(PRODUCT.img);
      inner.appendChild(img);
    }
    var info = D.createElement('div'); info.className = 'ow-cb-sticky__info'; inner.appendChild(info);
    var titleEl = D.createElement('div'); titleEl.className = 'ow-cb-sticky__title'; info.appendChild(titleEl);
    var titleT = textNode(titleEl, PRODUCT.title || '');
    var priceEl = D.createElement('div'); priceEl.className = 'ow-cb-sticky__price'; info.appendChild(priceEl);
    var priceT = textNode(priceEl, '');
    var btn = D.createElement('button'); btn.type = 'button'; btn.className = 'ow-cb-sticky__btn'; inner.appendChild(btn);
    var btnSpan = D.createElement('span'); btn.appendChild(btnSpan);
    var btnT = textNode(btnSpan, st.label || 'Add to Cart');
    D.body.appendChild(bar);

    /* "RM 58.76" (MYR) has neither a "$" nor a currency sign: every symbol the table prints counts
       (letters only when not inside a word), plus the old signs / "ABC 12" test (fix 2026-10-07). */
    var SYM_PRICE = (function () {
      var alts = ['\\$'];
      for (var k in OW_CUR) {
        if (!Object.prototype.hasOwnProperty.call(OW_CUR, k)) continue;
        var y = String(OW_CUR[k][0]).replace(/\s+$/, '');
        if (y) alts.push(y.replace(/[.*+?^$(){}|[\]\\]/g, '\\$&'));
      }
      return new RegExp('(?:^|[^A-Za-z])(?:' + alts.join('|') + ')\\s?\\d');
    })();
    function labelHasPrice(label) {
      return /\d/.test(label) && (/[$\u00a3\u20ac\u00a5\u20b9\u20a9\u20aa\u20ba\u20b1\u0e3f]|[A-Z]{3}\s?\d/.test(label) || SYM_PRICE.test(label));
    }
    var shown = false, past = false, lastTap = 0, srcLabel = null;
    /* The bar's button is narrower than the theme's (max 60% / 62% of the bar), so the pack label
       the bundle box fitted to the full-width theme button can be cut at its END \u2014 the price.
       Shorten our own copy the box's way ("Add 4 patterns \u2013 \u00a3x" \u2192 "Add 4 \u2013 \u00a3x" \u2192 "Add \u2013 \u00a3x" \u2192
       "\u00a3x"), whatever the currency (USD too). Written only when the source label changes (sync
       runs after every page change; writing full-then-short each time would never settle);
       a width or font change re-fits. */
    function fits() { try { return !btnSpan.clientWidth || btnSpan.scrollWidth <= btnSpan.clientWidth + 1; } catch (e) { return true; } }
    function fitSticky(label) {
      var opts = [label], m = /^(.*?)\s+\u2013\s+(.+)$/.exec(label);
      if (m) {
        var c = /^Add (\d+)\b/.exec(m[1]);
        if (c && m[1] !== 'Add ' + c[1]) opts.push('Add ' + c[1] + ' \u2013 ' + m[2]);
        opts.push('Add \u2013 ' + m[2], m[2]);
      }
      for (var i = 0; i < opts.length; i++) {
        setText(btnT, opts[i]);
        if (fits()) return;
      }
    }
    function refitSticky() { srcLabel = null; sync(); }
    function show(on) {
      on = !!on && !(btn.disabled && !labelOf(themeBtn));
      if (on === shown) return;
      shown = on;
      if (on) { addClass(bar, 'ow-cb-sticky--on'); bar.setAttribute('aria-hidden', 'false'); }
      else { removeClass(bar, 'ow-cb-sticky--on'); bar.setAttribute('aria-hidden', 'true'); }
      raf(function () { setLift(shown && bar.offsetHeight ? bar.offsetHeight : 0); });
    }
    function sync() {
      if (!themeBtn || !D.contains(themeBtn)) {
        var nb = findButton();
        if (nb && nb !== themeBtn) { themeBtn = nb; watch(); }
      }
      var label = labelOf(themeBtn) || st.label || 'Add to Cart';
      if (label !== srcLabel) { srcLabel = label; fitSticky(label); }
      var disabled = !!(themeBtn && (themeBtn.disabled || themeBtn.getAttribute('aria-disabled') === 'true'));
      btn.disabled = disabled;
      /* A pack label carries its own price ("Add 4 \u2013 \u00a312.60"): no second price beside it. */
      var p = priceText(), withPrice = labelHasPrice(label);
      setText(priceT, withPrice ? '' : p);
      priceEl.hidden = withPrice || !p;
      if (PRODUCT.title) setText(titleT, PRODUCT.title);
    }
    var io = null;
    function watch() {
      if (!W.IntersectionObserver || !themeBtn) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        show(past);
      });
      io.observe(themeBtn);
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var now = Date.now();
      if (now - lastTap < 1200) return; /* one tap = one add */
      lastTap = now;
      if (!themeBtn || !D.contains(themeBtn)) themeBtn = findButton();
      if (!themeBtn || themeBtn.disabled || themeBtn.getAttribute('aria-disabled') === 'true') return;
      /* The theme's own button: the bundle box's capture listener (when a pack is chosen) or
         the theme's product form handles the add \u2014 never this script. */
      themeBtn.click();
    });
    sync();
    watch();
    onDomFrame(sync);
    W.addEventListener('pageshow', function (e) { if (e && e.persisted) { lastTap = 0; refitSticky(); } });
    var resizeQueued = false, lastWidth = W.innerWidth;
    W.addEventListener('resize', function () {
      /* Width only: a phone's address bar showing / hiding changes the height on every scroll. */
      if (resizeQueued || W.innerWidth === lastWidth) return;
      resizeQueued = true;
      raf(function () { resizeQueued = false; lastWidth = W.innerWidth; refitSticky(); });
    });
    try {
      if (D.fonts) {
        if (D.fonts.ready && D.fonts.ready.then) D.fonts.ready.then(function () { safe('sticky fit', refitSticky); });
        if (D.fonts.addEventListener) D.fonts.addEventListener('loadingdone', function () { safe('sticky fit', refitSticky); });
      }
    } catch (e) {}
  });

  /* \u2500\u2500 3. Related products: printed by the theme section; hidden while Vitals still shows its own. \u2500\u2500 */
  safe('related', function () {
    if (C.related && vitalsHas(22)) addClass(HTML, 'ow-cb-vrp');
  });

  /* \u2500\u2500 4. Scroll to top \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('scroll top', function () {
    var t = C.scrollTop;
    if (!t) return;
    var b = D.createElement('button');
    b.type = 'button';
    b.className = 'ow-cb-top ow-cb-fixed ow-cb-top--' + (t.pos === 'bottom_left' ? 'bl' : 'br');
    b.setAttribute('aria-label', 'Back to top');
    b.setAttribute('data-ow-noconv', '');
    b.style.setProperty('--ow-top-bg', t.bg || '#111111');
    b.style.setProperty('--ow-top-fg', t.fg || '#ffffff');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 5l-7 7 1.4 1.4L11 8.8V20h2V8.8l4.6 4.6L19 12z" fill="currentColor"/></svg>';
    b.tabIndex = -1;
    D.body.appendChild(b);
    var on = false, queued = false;
    function check() {
      queued = false;
      var y = W.pageYOffset || HTML.scrollTop || 0;
      var want = y > Math.max(400, (W.innerHeight || 600) * 0.8);
      if (want === on) return;
      on = want;
      if (on) { addClass(b, 'ow-cb-top--on'); b.tabIndex = 0; } else { removeClass(b, 'ow-cb-top--on'); b.tabIndex = -1; }
    }
    W.addEventListener('scroll', function () { if (!queued) { queued = true; raf(check); } }, { passive: true });
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var reduce = false;
      try { reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (x) {}
      try { W.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (x) { W.scrollTo(0, 0); }
    });
    check();
  });

  /* \u2500\u2500 5. Inactive tab message \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('inactive tab', function () {
    var t = C.inactiveTab;
    if (!t || !t.message || vitalsHas(13) || typeof D.hidden === 'undefined') return;
    /* "shown" is what document.title reads back after we set it: the browser collapses spaces
       ("Come  back" reads "Come back"), so comparing with the raw message never matched (fix 2026-10-07). */
    var saved = null, shown = null;
    D.addEventListener('visibilitychange', function () {
      try {
        if (D.hidden) { if (saved === null) { saved = D.title; D.title = String(t.message); shown = D.title; } }
        else if (saved !== null) { if (D.title === shown) D.title = saved; saved = null; shown = null; }
      } catch (e) {}
    });
  });

  /* \u2500\u2500 6. Product label \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('label', function () {
    var L = C.label;
    if (!L || !(L.ids && L.ids.length) && !(L.handles && L.handles.length)) return;
    var IDS = {}, HANDLES = {}, i;
    for (i = 0; i < (L.ids || []).length; i++) IDS[String(L.ids[i])] = 1;
    for (i = 0; i < (L.handles || []).length; i++) HANDLES[String(L.handles[i]).toLowerCase()] = 1;
    function wanted(id, handle) { return (id && IDS[String(id)] === 1) || (handle && HANDLES[String(handle).toLowerCase()] === 1); }
    function make() {
      var el = D.createElement('span');
      el.className = 'ow-cb-label ow-cb-label--' + (L.layout === 'strip' ? 'strip' : L.layout === 'circle' ? 'circle' : 'rect');
      el.setAttribute('data-ow-noconv', '');
      el.setAttribute('aria-hidden', 'true');
      var s = el.style;
      s.background = L.bg; s.color = L.fg; s.fontSize = L.size + 'px'; s.opacity = String(Math.max(0, Math.min(100, L.o)) / 100);
      s.height = L.h + 'px';
      s.top = L.v + '%';
      if (L.layout === 'strip') { s.left = '0'; s.width = '100%'; s.borderRadius = '0'; s.transform = 'translateY(-' + L.v + '%)'; }
      else {
        var w = L.layout === 'circle' ? Math.max(L.w, L.h) : L.w;
        if (L.layout === 'circle') s.height = w + 'px';
        s.width = w + 'px';
        s.left = L.x + '%';
        s.borderRadius = L.layout === 'circle' ? '50%' : L.r + 'px';
        s.transform = 'translate(-' + L.x + '%, -' + L.v + '%)';
      }
      textNode(el, L.text);
      return el;
    }
    function host(el) {
      try { if (W.getComputedStyle(el).position === 'static') el.style.position = 'relative'; } catch (e) {}
      return el;
    }
    function ensure(container) {
      if (!container) return;
      for (var k = 0; k < container.children.length; k++) if ((' ' + container.children[k].className + ' ').indexOf(' ow-cb-label ') !== -1) return;
      host(container).appendChild(make());
    }
    /* The product page: the label goes on the FIRST image the shopper sees, never on the whole
       gallery (fix 2026-10-07). Dawn's desktop "stacked" and "columns" layouts put every image in one
       slider-component, so a % of the gallery drifted down (stacked) or landed on the second image
       (columns). The anchor is the active media item when it is shown (Dawn moves is-active to the
       variant's image, which it also puts first), else the first shown item; slider-component /
       media-gallery only for a gallery without Dawn's media items. When the anchor changes (a
       thumbnail click in the thumbnail layouts), a label is added there and the others are hidden \u2014
       never moved or removed (no removed nodes: the cart guard re-checks the cart on those). */
    function shownEl(el) { try { return !!el && el.getClientRects().length > 0; } catch (e) { return false; } }
    function galleryAnchor() {
      var g = D.querySelector('slider-component[id^="GalleryViewer"]') || D.querySelector('media-gallery') || D.querySelector('.product__media-wrapper');
      if (!g) return null;
      var items = g.querySelectorAll('.product__media-item');
      if (!items.length) return { box: g, scope: g };
      var act = g.querySelector('.product__media-item.is-active');
      if (shownEl(act)) return { box: act, scope: g };
      for (var k = 0; k < items.length; k++) if (shownEl(items[k])) return { box: items[k], scope: g };
      return { box: act || items[0], scope: g };
    }
    var galObs = null, galWatched = null, galQueued = false;
    function watchGallery(el) {
      /* Thumbnail layouts: a click only moves the is-active class (no node added) \u2014 follow it. */
      if (!el || el === galWatched || !W.MutationObserver) return;
      if (galObs) galObs.disconnect();
      galWatched = el;
      galObs = new MutationObserver(function () {
        if (galQueued) return;
        galQueued = true;
        raf(function () { galQueued = false; safe('label: product page', productPage); });
      });
      galObs.observe(el, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    function productPage() {
      if (!L.product || !PRODUCT || !wanted(PRODUCT.id, PRODUCT.handle)) return;
      var a = galleryAnchor();
      if (!a) return;
      watchGallery(a.scope.closest ? (a.scope.closest('media-gallery') || a.scope) : a.scope);
      var have = a.scope.querySelectorAll('.ow-cb-label'), mine = null, k;
      for (k = 0; k < have.length; k++) if (!mine && have[k].parentNode === a.box) mine = have[k];
      for (k = 0; k < have.length; k++) {
        var want = have[k] === mine ? '' : 'none';
        if (have[k].style.display !== want) have[k].style.display = want;
      }
      if (!mine) host(a.box).appendChild(make());
    }
    function cardIdentity(card) {
      var a = card.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
      var id = a ? (/-(\d+)$/.exec(a.getAttribute('id') || '') || [])[1] : null;
      var link = a || card.querySelector('a[href*="/products/"]');
      var h = link ? (/\/products\/([^\/?#]+)/.exec(link.getAttribute('href') || '') || [])[1] : null;
      try { if (h) h = decodeURIComponent(h); } catch (e) {}
      return { id: id, handle: h };
    }
    function cards() {
      if (!L.cards) return;
      var list = D.querySelectorAll('.card-wrapper');
      for (var k = 0; k < list.length && k < 400; k++) {
        var c = list[k], who = cardIdentity(c);
        if (!wanted(who.id, who.handle)) continue;
        ensure(c.querySelector('.card__inner') || c.querySelector('.card__media'));
      }
    }
    function run() { safe('label: product page', productPage); safe('label: cards', cards); }
    run();
    onDomFrame(run);
  });
})();
